import { BsFileEarmarkDiff } from 'react-icons/bs';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { ChatItemReplaceController } from './chatReplaceInterface';
import { ChatItemReplaceViewProps } from './chatReplaceProps';
import { generateDiffSquares } from '../apply/chatApplyHelper';

export function createChatItemReplaceController(): ChatItemReplaceController {
    return {
        useProps(context, item, props): ChatItemReplaceViewProps {
            if (!item.result) {
                return {
                    isLoading: true,
                    Icon: BsFileEarmarkDiff,
                    label: 'Updating document',
                };
            }
            return {
                isLoading: false,
                Icon: BsFileEarmarkDiff,
                label: item.result ? `Updated document` : 'Updating document',
                document: {
                    icon: item.content?.icon
                        ? {
                              kind: 'emoji',
                              text: item.content.icon,
                          }
                        : {
                              kind: 'icon',
                              Component: HiOutlineDocumentText,
                          },
                    label: item.content?.title ?? 'Document',
                    onClick: () => {
                        props.onOpen();
                    },
                },
                summary: item.tool.args.summary
                    ? {
                          added: {
                              value: item.tool.args.summary.added,
                              label: `+${item.tool.args.summary.added}`,
                          },
                          removed: {
                              value: item.tool.args.summary.removed,
                              label: `-${item.tool.args.summary.removed}`,
                          },
                          visual: {
                              squares: generateDiffSquares(
                                  item.tool.args.summary.added,
                                  item.tool.args.summary.removed
                              ),
                          },
                      }
                    : null,
            };
        },
    };
}
